import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

const ConfirmChangeDialog = ({
  showDialog,
  handleDialog,
  setIsResetConfirmed,
  handleConfirmChange,
}) => (
  <Dialog open={showDialog} onClose={handleDialog}>
    <DialogTitle>Confirm Changing Patient</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to change the patient? Once you click 'Confirm,'
        all information in Section Two will be reset.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={() => {
          setIsResetConfirmed(false);
          handleDialog();
        }}
        sx={{
          width: '48%',
          fontFamily: 'Lato',
          textTransform: 'capitalize',
          color: 'var(--clr-theme-purple)',
          borderColor: 'var(--clr-theme-purple)',
        }}
      >
        Cancel
      </Button>
      <Button
        onClick={handleConfirmChange}
        sx={{
          alignItems: 'center',
          backgroundColor: 'var(--clr-theme-purple)!important',
          color: 'white',
          width: '48%',
          fontFamily: 'Lato',
          textTransform: 'capitalize',
        }}
      >
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmChangeDialog;
